import { ContentFooter } from "@app/components/core/ContentFooter/ContentFooter"
import { ContentHeader } from "@app/components/core/ContentHeader/ContentHeader"
import { InputError } from "@app/components/core/InputError/InputError"
import { Checkbox } from "@app/components/move2Library/Checkbox/Checkbox"
import Input from "@app/components/move2Library/Input/Input"
import { SelectBox } from "@app/components/move2Library/SelectBox/SelectBox"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import OrderContentBody from "@app/components/order/OrderContentBody/OrderContentBody"
import OrderSubPage from "@app/components/pageTypes/OrderSubPage/OrderSubPage"
import { OrderAnimationTypes } from "@app/components/routing/AnimatedOrderRoute/AnimatedOrderRoute"
import { setAddresses } from "@app/store/actions/orderActions"
import { useGetStrings } from "@app/store/service/cmsService"
import { useGetSalutations, useGetTransporterCountries, useSaveRelationAddress } from "@app/store/service/connectorService"
import { ADRESS_TYPES } from "@app/utils/constants"
import { getTransporterIdsForCountrySelection } from "@app/utils/getTransporterIds"
import { splitStreetToParts } from "@app/utils/stringUtils"
import { emailPattern } from "@app/utils/validations"
import { classNamez } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import { useCallback, useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import "./AddressDetails.css"

function getTransporterType(formattedOrder) {
	let ids = []
	for (let line of formattedOrder.orderLines) {
		if (line.transporterTypeId) {
			if (ids.indexOf(line.transporterTypeId) === -1) {
				ids.push(line.transporterTypeId)
			}
		}
	}
	if (ids.indexOf(6) !== -1 && ids.length > 1) {
		return 1
	} else if (ids.indexOf(6) === -1) {
		return 2
	} else if (ids.indexOf(6) !== -1) {
		return 3
	}
}

function TransporterInfo() {
	const formattedOrder = useSelector(state => state.order.formattedOrder)
	const {
		data: { transporter, delivery },
	} = useGetStrings(undefined, { defaultData: { transporter: [] } })

	const [string, setString] = useState("")

	useEffect(() => {
		let id = getTransporterType(formattedOrder)
		setString(transporter.find(e => e.id === id).text)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formattedOrder])

	return (
		<div>
			{delivery}:{" "}
			<span className="color-fg-secondary" style={{ fontStyle: "italic" }}>
				{string}
			</span>
		</div>
	)
}

function getDefaultFormValues(invoiceAddress, deliveryAddress, relation, htgGuestData) {
	return {
		salutation: invoiceAddress ? invoiceAddress.genderId : relation && relation.genderId && !relation.guest ? relation.genderId + "" : "",
		firstName: invoiceAddress
			? invoiceAddress.firstName
			: relation && !relation.guest
				? relation.firstName || ""
				: htgGuestData
					? htgGuestData.user?.firstname
					: "",
		lastName: invoiceAddress
			? invoiceAddress.lastName
			: relation && !relation.guest
				? relation.lastName || ""
				: htgGuestData
					? htgGuestData.user?.lastname
					: "",
		email: invoiceAddress ? invoiceAddress.email : relation && !relation.guest ? relation.email || "" : htgGuestData ? htgGuestData.user?.email : "",
		emailRepeat: invoiceAddress ? invoiceAddress.email : relation && !relation.guest ? relation.email || "" : htgGuestData ? htgGuestData.user?.email : "",
		phoneNo: invoiceAddress ? invoiceAddress.phoneNo : relation && !relation.guest ? relation.phoneNo || "" : "",
		street:
			invoiceAddress && invoiceAddress.address !== undefined
				? invoiceAddress.address + " " + (invoiceAddress.houseNo || invoiceAddress.houseNumber)
				: relation && !relation.guest && relation.address && (relation.houseNo || relation.houseNumber)
					? relation.address + " " + (relation.houseNo || relation.houseNumber) || ""
					: htgGuestData
						? htgGuestData.user?.street
						: "",
		zipCode: invoiceAddress ? invoiceAddress.zipCode : relation && !relation.guest ? relation.zipCode || "" : htgGuestData ? htgGuestData.user?.zip : "",
		city: invoiceAddress ? invoiceAddress.city : relation && !relation.guest ? relation.city || "" : htgGuestData ? htgGuestData.user?.city : "",
		countryId: invoiceAddress ? invoiceAddress.countryId + "" : relation && relation.countryId ? relation.countryId + "" : "",
		accountType: invoiceAddress ? (invoiceAddress.companyName?.length > 0 ? "firma" : "privat") : "privat",
		differentAddress: deliveryAddress && deliveryAddress.lastName ? true : false,
		differentEmailAddress: deliveryAddress ? true : false,
		companyName: invoiceAddress ? invoiceAddress.companyName : relation && !relation.guest ? relation.companyName : "",
		vatNumber: invoiceAddress ? invoiceAddress.vatNumber : relation && !relation.guest ? relation.vatNumber : "",
		differentSalutation: deliveryAddress ? deliveryAddress.genderId : "",
		differentFirstName: deliveryAddress ? deliveryAddress.firstName : "",
		differentLastName: deliveryAddress ? deliveryAddress.lastName : "",
		differentZipCode: deliveryAddress ? deliveryAddress.zipCode : "",
		differentCompany: deliveryAddress ? deliveryAddress.companyName : "",
		differentStreet: deliveryAddress && deliveryAddress.address ? deliveryAddress.address + " " + (deliveryAddress.houseNo || deliveryAddress.houseNumber) : "",
		differentCity: deliveryAddress ? deliveryAddress.city : "",
		differentEmail: deliveryAddress ? deliveryAddress.email : "",
		differentEmailRepeat: deliveryAddress ? deliveryAddress.email : "",
		addressAddition: invoiceAddress ? invoiceAddress.addressAddition || "" : "",
		differentAddressAddition: deliveryAddress ? deliveryAddress.addressAddition || "" : "",
	}
}

const AddressDetails = () => {
	const price = useSelector(state => state.order.formattedOrder.payAmount)
	const relation = useSelector(state => state.core.relation)
	const deliveryAddress = useSelector(state => state.core.deliveryAddress)
	const invoiceAddress = useSelector(state => state.core.invoiceAddress)
	const formattedOrder = useSelector(state => state.order.formattedOrder)
	const htgGuestData = useSelector("core.htgGuestData")
	const [showCompany, setShowCompany] = useState(relation && relation.relationTypeId === 2 ? true : false)
	const [useDifferentAddress, setUseDifferentAddress] = useState(deliveryAddress ? true : false)
	const [useDifferentEmailAddress, setUseDifferentEmailAddress] = useState(deliveryAddress ? true : false)
	const { push } = useCustomNavigation()
	const { data: salutations } = useGetSalutations()
	const { data: countries } = useGetTransporterCountries({ transporterIds: getTransporterIdsForCountrySelection(formattedOrder) })

	const [saveAddress] = useSaveRelationAddress()

	const {
		data: {
			addressDetailTitle,
			clientTypes,
			labelSalutation,
			addressDetailAccountTypeText,
			buttonNext,
			placeholderFirstName,
			placeholderLastName,
			placeholderEMail,
			placeholderEMailRepeat,
			placeholderPhone,
			placeholderAddress,
			placeholderPostalCode,
			placeholderCity,
			placeholderAddressAddition,
			placeholderCountry,
			placeholderCompany,
			placeholderVATNumber,
			requiredFields,
			pleaseSelect,
			errorInputMissingEmail,
			errorInputMissingFirstName,
			errorInputMissingLastName,
			errorInputMissingPostalCode,
			errorInputMissingCity,
			errorInputInvalidEmail,
			errorInputMissingSalutation,
			errorInputMissingAddress,
			errorInputMissingEmailRepeat,
			errorInputMissingCompany,
			errorInputMissingVATNumber,
			errorInputMissingCountry,
			errorInputMustBeTheSameEmailRepeat,
			errorInputInvalidAddress,
			addressDetailCheckboxDifferentAddress,
			addressDetailCheckboxDifferentEmail,
		},
	} = useGetStrings(undefined, { defaultData: {} })

	const {
		register,
		handleSubmit,
		formState: { errors },
		getValues,
		trigger,
		setValue,
	} = useForm({
		mode: "onTouched",
		defaultValues: getDefaultFormValues(invoiceAddress, deliveryAddress, relation, htgGuestData),
	})

	useEffect(() => {
		if (countries && htgGuestData) {
			if (htgGuestData.user?.country) {
				let country = countries.find(e => e.countryCode.toLowerCase() === htgGuestData.user?.country.toLowerCase())
				if (country) {
					setValue("countryId", country.countryId)
				}
			}
		} else if (countries) {
			setValue("countryId", getValues().countryId)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [countries, htgGuestData, setValue])

	let transporterType = getTransporterType(formattedOrder)
	const guestOrder = relation?.guest && transporterType == 3
	const saveDetails = useCallback(async () => {
		handleSubmit(async data => {
			const s1 = data.street ? splitStreetToParts(data.street) : undefined
			const nextInvoiceAddress = {
				addressTypeId: ADRESS_TYPES.INVOICE,
				firstName: data.firstName,
				lastName: data.lastName,
				companyName: data.companyName,
				zipCode: data.zipCode,
				genderId: data.salutation,
				phoneNo: data.phoneNo,
				city: data.city,
				countryId: data.countryId,
				address: s1?.street,
				houseNo: s1 ? s1?.number + (s1?.letter || "") : "",
				email: data.email,
				vatNumber: data.vatNumber,
				addressAddition: data.addressAddition,
			}
			if (guestOrder && (nextInvoiceAddress.countryId == "" || nextInvoiceAddress.countryId == "undefined")) {
				delete nextInvoiceAddress.countryId
			}
			const s2 = data.differentAddress && data.differentStreet ? splitStreetToParts(data.differentStreet) : undefined
			const nextDeliveryAddress =
				data.differentAddress || data.differentEmailAddress
					? {
							addressTypeId: ADRESS_TYPES.DELIVERY,
							email: data.differentEmail,
							firstName: data.differentFirstName || undefined,
							lastName: data.differentLastName || undefined,
							companyName: data.differentCompany || undefined,
							vatNumber: data.vatNumber || undefined,
							zipCode: data.differentZipCode || undefined,
							city: data.differentCity || undefined,
							genderId: data.differentSalutation || undefined,
							countryId: data.differentCountryId || undefined,
							address: s2 ? s2.street : undefined,
							houseNo: s2 ? s2.number + (s2.letter || "") : undefined,
							addressAddition: data.differentAddressAddition,
						}
					: undefined

			if (relation && !relation.guest && !invoiceAddress) {
				//a relation without a invoice address so we need to create one
				saveAddress({ address: nextInvoiceAddress })
					.unwrap()
					.then(addresses => {
						setAddresses([nextDeliveryAddress, addresses[addresses.length - 1]])
						push("order/next-order-overview", OrderAnimationTypes.fullSlide)
					})

				return
			} else {
				setAddresses([nextDeliveryAddress, nextInvoiceAddress])

				push("order/next-order-overview", OrderAnimationTypes.fullSlide)
			}
		})()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [handleSubmit, relation])

	const next = useCallback(() => {
		saveDetails()
	}, [saveDetails])

	return (
		<OrderSubPage className="h-100">
			<ContentHeader canGoBack colorStyle="white" animation={OrderAnimationTypes.fullSlide}>
				{addressDetailTitle}
			</ContentHeader>
			<OrderContentBody className="flex flex-column container-lg f4 mt-2" scrollable>
				<TransporterInfo />
				<form>
					<div className="addressDetails__inputRow addressDetails__inputRow--3">
						<div>
							<div className="regular f5  mb-2">{labelSalutation} *</div>
							<div className="flex flex-items-center">
								{(salutations || []).map((e, i) => (
									<div key={i} className={"flex flex-items-center" + classNamez({ "ml-3": i !== 0 })}>
										<input
											id={"1_" + e.salutation}
											type="radio"
											{...register("salutation", { required: { value: true, message: errorInputMissingSalutation } })}
											value={e.genderId}
											onChange={() => {}}
										/>
										<label htmlFor={"1_" + e.value} className="ml-2">
											{e.salutation}
										</label>
									</div>
								))}
							</div>
							<InputError message={errors.salutation ? errors.salutation.message : undefined} />
						</div>
						<div>
							<div className="regular f5 mb-2">{addressDetailAccountTypeText} *</div>
							<div className="flex">
								{(clientTypes || []).map((e, i) => (
									<div key={i} className={"flex flex-items-center" + classNamez({ "ml-3": i !== 0 })}>
										<input
											id={e.value}
											type="radio"
											{...register("accountType", { required: { value: true, message: "missing" } })}
											value={e.value}
											onChange={e => {
												setShowCompany(e.target.value === "firma")
											}}
										/>
										<label htmlFor={e.value} className="ml-2">
											{e.name}
										</label>
									</div>
								))}
							</div>
							<InputError message={errors.accountType ? errors.accountType.message : undefined} />
						</div>
					</div>

					{showCompany && (
						<div className="addressDetails__inputRow addressDetails__inputRow--3">
							<div>
								<Input
									type="text"
									label={placeholderCompany + "*"}
									formRegister={register("companyName", {
										required: {
											value: true,
											message: errorInputMissingCompany,
										},
									})}
									errors={errors}
								/>
							</div>
							<div>
								<Input
									type="text"
									label={placeholderVATNumber + "*"}
									formRegister={register("vatNumber", {
										required: {
											value: true,
											message: errorInputMissingVATNumber,
										},
									})}
									errors={errors}
								/>
							</div>
						</div>
					)}

					<div className="addressDetails__inputRow addressDetails__inputRow--3">
						<div>
							<Input
								name="firstname"
								type="text"
								label={placeholderFirstName + "*"}
								autocomplete="given-name"
								formRegister={register("firstName", {
									required: {
										value: true,
										message: errorInputMissingFirstName,
									},
								})}
								errors={errors}
							/>
						</div>
						<div>
							<Input
								name="lastname"
								type="text"
								label={placeholderLastName + "*"}
								autocomplete="family-name"
								formRegister={register("lastName", {
									required: {
										value: true,
										message: errorInputMissingLastName,
									},
								})}
								errors={errors}
							/>
						</div>
					</div>

					<div className="addressDetails__inputRow addressDetails__inputRow--3">
						<SelectBox
							classname="selectbox border rounded-1 fill"
							autocomplete="country"
							formRegister={register("countryId", {
								required: {
									value: guestOrder ? false : true,
									message: errorInputMissingCountry,
								},
							})}
							errors={errors}
							label={placeholderCountry + (guestOrder ? "" : "*")}
							onChange={e => {
								setValue("countryId", e.target.value)
							}}
						>
							{guestOrder ? (
								<option value="" disabled style={{ display: "none" }}>
									{pleaseSelect}
								</option>
							) : (
								<option value="" disabled style={{ display: "none" }}>
									{pleaseSelect}*
								</option>
							)}
							{countries &&
								countries.map(country => {
									return (
										<option key={country.countryId + ""} value={country.countryId + ""}>
											{country.country}
										</option>
									)
								})}
						</SelectBox>

						<Input
							name="street"
							type="text"
							label={guestOrder ? placeholderAddress : placeholderAddress + "*"}
							autocomplete="on"
							formRegister={register("street", {
								required: {
									value: guestOrder ? false : true,
									message: errorInputMissingAddress,
								},
								validate: value => {
									if (value) {
										try {
											splitStreetToParts(value)
											return true
										} catch {
											return errorInputInvalidAddress
										}
									}
								},
							})}
							errors={errors}
						/>
					</div>

					<div className="addressDetails__inputRow addressDetails__inputRow--1_2">
						<Input
							className="addressDetails__postalcode"
							name="postalCode"
							type="text"
							label={guestOrder ? placeholderPostalCode : placeholderPostalCode + "*"}
							autocomplete="postal-code"
							formRegister={register("zipCode", {
								required: {
									value: guestOrder ? false : true,
									message: errorInputMissingPostalCode,
								},
							})}
							errors={errors}
						/>
						<Input
							className="addressDetails__city"
							name="city"
							type="text"
							label={guestOrder ? placeholderCity : placeholderCity + "*"}
							autocomplete="address-level2"
							formRegister={register("city", {
								required: {
									value: guestOrder ? false : true,
									message: errorInputMissingCity,
								},
							})}
							errors={errors}
						/>
						<Input
							className="addressDetails__addressAddition"
							name="addressAddition"
							type="text"
							label={placeholderAddressAddition}
							formRegister={register("addressAddition", {})}
							errors={errors}
						/>
					</div>

					<div className="addressDetails__inputRow addressDetails__inputRow--3">
						<Input name="phoneNo" type="tel" label={placeholderPhone} autocomplete="on" formRegister={register("phoneNo", {})} errors={errors} />
						{/* <Input
                            label={placeholderBirthday}
                            name={"birthday"}
                            type="date"
                            autocomplete={"on"}
                            formRegister={register("birthday", {
                                validate: (value) => {
                                    return true;
                                }
                            })}
                            errors={errors}
                        /> */}
					</div>

					<div className="addressDetails__inputRow addressDetails__inputRow--3">
						<div>
							<Input
								name="email"
								type="email"
								label={placeholderEMail + "*"}
								autocomplete="email"
								formRegister={register("email", {
									required: {
										value: true,
										message: errorInputMissingEmail,
									},
									pattern: {
										value: emailPattern,
										message: errorInputInvalidEmail,
									},
									validate: () => {
										if (getValues("emailRepeat").length) {
											trigger("emailRepeat")
										}
										return true
									},
								})}
								errors={errors}
							/>
						</div>
						<div>
							<Input
								name="emailRepeat"
								type="email"
								label={placeholderEMailRepeat + "*"}
								formRegister={register("emailRepeat", {
									required: {
										value: true,
										message: errorInputMissingEmailRepeat,
									},
									validate: {
										equalsEmail: value => value === getValues().email || errorInputMustBeTheSameEmailRepeat,
									},
								})}
								errors={errors}
							/>
						</div>
					</div>

					<div className="mt-2" style={{ fontStyle: "italic" }}>
						* {requiredFields}
					</div>

					<div className="mt-4">
						{(transporterType == 1 || transporterType === 2) && (
							<Checkbox
								label={addressDetailCheckboxDifferentAddress}
								formRegister={register("differentAddress")}
								className="mt-3"
								onClick={e => {
									setUseDifferentAddress(e.target.checked)
									setUseDifferentEmailAddress(e.target.checked)
								}}
								checked={false}
							/>
						)}
						{transporterType == 3 && (
							<Checkbox
								label={addressDetailCheckboxDifferentEmail}
								formRegister={register("differentEmailAddress")}
								className="mt-3"
								onClick={e => {
									setUseDifferentAddress(e.target.checked)
									setUseDifferentEmailAddress(e.target.checked)
								}}
								checked={false}
							/>
						)}
					</div>

					{useDifferentAddress && (
						<>
							<div className="mt-6">
								{(getTransporterType(formattedOrder) === 1 || getTransporterType(formattedOrder) === 2) && (
									<>
										<div className="addressDetails__inputRow addressDetails__inputRow--3">
											<div>
												<div className="regular f5 mb-2">{labelSalutation} *</div>
												<div className="flex">
													{(salutations || []).map((e, i) => (
														<div key={i} className={classNamez({ "ml-3": i !== 0 })}>
															<input
																id={"2_" + e.value}
																type="radio"
																{...register("differentSalutation", {
																	required: { value: true, message: errorInputMissingSalutation },
																})}
																value={e.id}
																onChange={() => {}}
															/>
															<label htmlFor={"2_" + e.value} className="ml-2">
																{e.value}
															</label>
														</div>
													))}
												</div>
												<InputError message={errors.differentSalutation ? errors.differentSalutation.message : undefined} />
											</div>
										</div>

										{getTransporterType(formattedOrder) === 1 && (
											<>
												<div className="addressDetails__inputRow addressDetails__inputRow--3">
													<div>
														<Input
															name="differentEmail"
															type="email"
															label={placeholderEMail + "*"}
															autocomplete="email"
															formRegister={register("differentEmail", {
																required: {
																	value: true,
																	message: errorInputMissingEmail,
																},
																pattern: {
																	value: emailPattern,
																	message: errorInputInvalidEmail,
																},
																validate: () => {
																	if (getValues("differentEmailRepeat").length) {
																		trigger("differentEmailRepeat")
																	}
																	return true
																},
															})}
															errors={errors}
														/>
													</div>
													<div>
														<Input
															name="differentEmailRepeat"
															type="email"
															label={placeholderEMailRepeat + "*"}
															formRegister={register("differentEmailRepeat", {
																required: {
																	value: true,
																	message: errorInputMissingEmailRepeat,
																},
																validate: {
																	equalsEmail: value => value === getValues().differentEmail || errorInputMustBeTheSameEmailRepeat,
																},
															})}
															errors={errors}
														/>
													</div>
												</div>
											</>
										)}

										<div className="addressDetails__inputRow addressDetails__inputRow--3">
											<div>
												<Input type="text" label={placeholderCompany} formRegister={register("differentCompany", {})} errors={errors} />
											</div>
										</div>

										<div className="addressDetails__inputRow addressDetails__inputRow--3">
											<div>
												<Input
													name="firstname"
													type="text"
													label={placeholderFirstName + "*"}
													autocomplete="given-name"
													formRegister={register("differentFirstName", {
														required: {
															value: true,
															message: errorInputMissingFirstName,
														},
													})}
													errors={errors}
												/>
											</div>
											<div>
												<Input
													name="lastname"
													type="text"
													label={placeholderLastName + "*"}
													autocomplete="family-name"
													formRegister={register("differentLastName", {
														required: {
															value: true,
															message: errorInputMissingLastName,
														},
													})}
													errors={errors}
												/>
											</div>
										</div>

										<div className="addressDetails__inputRow addressDetails__inputRow--3">
											<SelectBox
												classname="selectbox border rounded-1 fill"
												autocomplete="country"
												formRegister={register("differentCountryId", {
													required: {
														value: true,
														message: errorInputMissingCountry,
													},
												})}
												errors={errors}
												label={placeholderCountry + "*"}
												onChange={e => {
													setValue("differentCountryId", e.target.value)
												}}
											>
												<option value="" disabled style={{ display: "none" }}>
													{pleaseSelect}*
												</option>
												{countries &&
													countries.map(country => {
														return (
															<option key={country.countryId} value={country.countryId}>
																{country.country}
															</option>
														)
													})}
											</SelectBox>
											<Input
												name="street"
												type="text"
												label={placeholderAddress + "*"}
												autocomplete="on"
												formRegister={register("differentStreet", {
													required: {
														value: true,
														message: errorInputMissingAddress,
													},
													validate: value => {
														try {
															splitStreetToParts(value)
															return true
														} catch {
															return errorInputInvalidAddress
														}
													},
												})}
												errors={errors}
											/>
										</div>

										<div className="addressDetails__inputRow addressDetails__inputRow--1_2">
											<Input
												name="postalCode"
												type="text"
												label={placeholderPostalCode + "*"}
												autocomplete="postal-code"
												formRegister={register("differentZipCode", {
													required: {
														value: true,
														message: errorInputMissingPostalCode,
													},
												})}
												errors={errors}
											/>
											<Input
												name="city"
												type="text"
												label={placeholderCity + "*"}
												autocomplete="address-level2"
												formRegister={register("differentCity", {
													required: {
														value: true,
														message: errorInputMissingCity,
													},
												})}
												errors={errors}
											/>
										</div>
									</>
								)}
							</div>
						</>
					)}
					{useDifferentEmailAddress && (
						<>
							<div className="addressDetails__inputRow addressDetails__inputRow--3">
								<div>
									<Input
										name="differentEmail"
										type="email"
										label={placeholderEMail + "*"}
										autocomplete="email"
										formRegister={register("differentEmail", {
											required: {
												value: true,
												message: errorInputMissingEmail,
											},
											pattern: {
												value: emailPattern,
												message: errorInputInvalidEmail,
											},
											validate: () => {
												if (getValues("differentEmailRepeat").length) {
													trigger("differentEmailRepeat")
												}
												return true
											},
										})}
										errors={errors}
									/>
								</div>
								<div>
									<Input
										name="differentEmailRepeat"
										type="email"
										label={placeholderEMailRepeat + "*"}
										formRegister={register("differentEmailRepeat", {
											required: {
												value: true,
												message: errorInputMissingEmailRepeat,
											},
											validate: {
												equalsEmail: value => value === getValues().differentEmail || errorInputMustBeTheSameEmailRepeat,
											},
										})}
										errors={errors}
									/>
								</div>
							</div>
						</>
					)}
				</form>
			</OrderContentBody>

			<ContentFooter roundPrice={false} process={7} price={price} priceAbsolute buttonProps={{ text: buttonNext, onNext: next }} />
		</OrderSubPage>
	)
}

export default AddressDetails
